module.exports = __webpack_public_path__ + "img/header.e7f6c35b.png";